var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 7,
    cy: 7,
    r: 6.125,
    fill: "#009B62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17 9.087a.437.437 0 0 1-.308-.128L4.21 7.309a.44.44 0 0 1 0-.62.44.44 0 0 1 .618 0l1.342 1.342 2.998-2.998a.44.44 0 0 1 .619 0c.169.17.169.45 0 .618L6.48 8.96a.437.437 0 0 1-.31.128z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupDone);
export default __webpack_public_path__ + "static/media/pickup_done.0881139bac104887e9c6035f114aeef7.svg";
export { ForwardRef as ReactComponent };